export default function Section3() {
    return (
      <div className="Section3 py-[50px] md:py-[80px] bg-[#f9f9f9]">
        {/* Headline */}
        <div className="text-center mb-[50px]">
          <h2 className="text-[28px] md:text-[36px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
            Proven Results for Over 300 Global Brands
          </h2>
        </div>
  
        {/* Metrics */}
        <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16 text-center mx-auto w-[90%] md:w-[80%]">
          <div className="metric">
            <h3 className="text-[32px] md:text-[40px] font-bold text-[#DA2128]">500+</h3>
            <p className="text-[16px] md:text-[18px] text-[#373737] mt-2">
              Campaigns Executed in the Last 12 Months
            </p>
          </div>
  
          <div className="metric">
            <h3 className="text-[32px] md:text-[40px] font-bold text-[#DA2128]">150%</h3>
            <p className="text-[16px] md:text-[18px] text-[#373737] mt-2">
              Average Conversion Rate Increase
            </p>
          </div>
  
          <div className="metric">
            <h3 className="text-[32px] md:text-[40px] font-bold text-[#DA2128]">4.9/5</h3>
            <p className="text-[16px] md:text-[18px] text-[#373737] mt-2">
              Client Satisfaction
            </p>
          </div>
        </div>
  
        {/* Visuals / Graphics */}
        <div className="mt-[60px] flex flex-wrap justify-center items-center gap-8">
          {/* Placeholder for client logos */}
          <img
            src="../../../../assets/zuni-clients.png"
            alt="Client Logo"
            className="h-[50px] md:h-[90px]"
          />
          <img
            src="../../../../assets/wheelrack-clients.png"
            alt="Client Logo"
            className="h-[50px] md:h-[90px]"
          />
         
          {/* Add more logos as needed */}
        </div>
      </div>
    );
  }
  